<template>
  <div class="user">
    <div class="photo">
       <img v-if="userInfo.avatar" :src="userInfo.avatar"/>
      <img v-else="" :src="'../../../static/img/faces/face-0.jpg'" width="10"/> 
    </div>
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
             Hi {{user.name}}!
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <router-link :to="'/pages/user/'">
                <span class="sidebar-mini"></span>
                <span class="sidebar-normal"></span>
              </router-link>
            </li>
            <li>
              <router-link :to="'/pages/user/'">
                <span class="sidebar-mini">Pr</span>
                <span class="sidebar-normal">My Profile</span>
              </router-link>
            </li>
            <li>
              <a href="javascript:void(0)" @click="logout">
                <span class="sidebar-mini">Lo</span>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>

          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { AUTH_LOGOUT } from '../../../store/actions/auth'
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true,
        
      }
    },
    computed:{
      user(){
        const token = localStorage.getItem('vuex')
        const parsed = JSON.parse(token)
        return parsed['auth']
      },
       userInfo(){
        return this.$store.getters.getProfile
       }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },

      logout: function () {
        console.log('LOGGING OUT')
        this.$store.dispatch(AUTH_LOGOUT).then(() => {
          this.$router.push('/login')
        })
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue